module.exports = "<uib-tabset active=\"$ctrl.active\" justified=\"$ctrl.justified\" type=\"{{$ctrl.type}}\" vertical=\"$ctrl.vertical\">\n    <uib-tab index=\"$index\" ng-repeat=\"tab in $ctrl.tabs\" heading=\"{{tab.title}}\">\n        <div bind-dynamic-page=\"tab.content\"></div>\n    </uib-tab>\n</uib-tabset>"


//////////////////
// WEBPACK FOOTER
// ./client/components/tabs-widget/tabs-widget.component.html
// module id = 625
// module chunks = 0